import { AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui-kit/accordion';
import { useTranslation } from 'react-i18next';
import { FormControl, FormField, FormItem, FormLabel } from '@/components/ui-kit/form';
import { Label } from '@/components/ui-kit/label';
import { Switch } from '@/components/ui-kit/switch';
import { InfoTooltip } from '@/components/ui-kit/info-tool-tip';
import { UseFormReturn } from 'react-hook-form';
import { AgentBehaviorSettingsForm } from '@/modules/gpt-chats/components/agents-configuration/components/config-card-section/utils';
import { useState, useEffect } from 'react';

type MemorySectionProps = {
  control: UseFormReturn<AgentBehaviorSettingsForm>['control'];
  form: UseFormReturn<AgentBehaviorSettingsForm>;
  isMobile: boolean;
  onSubmit: (values: AgentBehaviorSettingsForm) => Promise<void>;
};

export const MemorySection = ({ control, form, onSubmit }: MemorySectionProps) => {
  const { t } = useTranslation();
  const [conversationsValue, setConversationsValue] = useState<number>(5);

  useEffect(() => {
    const currentValue = form.getValues('memory_config.last_n_conversations');
    if (typeof currentValue === 'number') {
      setConversationsValue(currentValue);
    }
  }, [form]);
  return (
    <AccordionItem value="memory">
      <div className="relative">
        <AccordionTrigger className="px-5 text-lg hover:no-underline">
          <Label htmlFor="memory-toggle" className="text-lg">
            {t('MEMORY')}
          </Label>
        </AccordionTrigger>

        {/* <div
          className="absolute right-12 top-1/2 z-10 -translate-y-1/2"
          onClick={(e) => e.stopPropagation()}
          onMouseDown={(e) => e.stopPropagation()}
        >
          <Switch id="memory-toggle" checked={true} disabled className="opacity-50" />
        </div> */}
      </div>
      <AccordionContent className={`w-full px-5 xl:w-1/2`}>
        <div className="grid gap-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <FormLabel className="text-sm font-medium">{t('SUMMARY')}</FormLabel>
              <InfoTooltip content={t('SUMMARY_TOOLTIP')} />
            </div>
            <FormField
              control={control}
              name="memory_config.enable_summary"
              render={({ field }) => (
                <Switch checked={!!field.value} onCheckedChange={field.onChange} />
              )}
            />
          </div>

          <div>
            <FormLabel className="mb-3 block text-sm font-medium">{t('ROUNDS')}</FormLabel>
            <FormField
              control={control}
              name="memory_config.last_n_conversations"
              render={({ field }) => (
                <FormItem>
                  <FormControl>
                    <input
                      type="number"
                      min={1}
                      max={20}
                      value={conversationsValue}
                      onChange={(e) => {
                        const value = parseInt(e.target.value) || 10;
                        const clampedValue = Math.min(Math.max(value, 1), 20);
                        setConversationsValue(clampedValue);
                      }}
                      onBlur={() => {
                        const currentValue = form.getValues('memory_config.last_n_conversations');
                        if (currentValue !== conversationsValue) {
                          field.onChange(conversationsValue);
                          onSubmit(form.getValues());
                        }
                      }}
                      className="w-full rounded-lg border bg-card px-4 py-3 text-lg font-medium text-high-emphasis focus:border-primary focus:outline-none"
                    />
                  </FormControl>
                  <div className="mt-2 text-sm text-high-emphasis">
                    {t('ROUNDS_DESCRIPTION')}
                  </div>
                </FormItem>
              )}
            />
          </div>
        </div>
      </AccordionContent>
    </AccordionItem>
  );
};
